export default __webpack_public_path__ + "static/media/Mask of the Great Impi.4be8f760.jpg";